const home = '/'
const about = '/om'
const singleItem = '/:id'
const search = '/sok'

export const RoutingPath = {
    home,
    about,
    singleItem,
    search
}